import { ApiClient } from "@/services/apiClient/ApiClient";
import { type AxiosResponse } from "axios";
import { type ApiData_UpdateCollectionItem, type CollectionItem, type CollectionItemId, type CreateCollectionItemData, Api_ItemPatchOperation } from "@/services/collection/item/collectionItemTypes";
import { CollectionItem_Schema } from "./collectionItemSchema";

/*
 * ===================================================================
 *
 * Collection items fetching.
 * eg. lists, details
 *
 * ===================================================================
 */

export async function fetchCollectionItemById(itemId: CollectionItemId): Promise<CollectionItem> {
  const url = "api/collection/item/" + itemId;
  return ApiClient.get<CollectionItem>(url).then(({ data }) => CollectionItem_Schema.parse(data));
}

/*
 * ===================================================================
 *
 * Collection items creating.
 *
 * ===================================================================
 */

export async function createCollectionItem(data: CreateCollectionItemData): Promise<CollectionItem> {
  return ApiClient.post<CollectionItem>("api/collection/item", {}, data).then(({ data }) => data);
}

/*
 * ===================================================================
 *
 * Collection items deleting.
 *
 * ===================================================================
 */

export async function deleteCollectionItem(itemId: CollectionItemId): Promise<AxiosResponse> {
  const url = "api/collection/item/" + itemId;
  return ApiClient.delete(url);
}

/*
 * ===================================================================
 *
 * Collection items manipulation.
 * eg. update, archivate, etc.
 *
 * ===================================================================
 */

export async function updateCollectionItem(itemId: CollectionItemId, data: ApiData_UpdateCollectionItem): Promise<CollectionItem> {
  const url = "api/collection/item/" + itemId;
  return ApiClient.put<CollectionItem>(url, {}, data).then(({ data }) => data);
}

export const archivateCollectionItem = async (itemId: CollectionItemId): Promise<AxiosResponse> => {
  const url = "api/collection/item/" + itemId;
  const params = { operation: Api_ItemPatchOperation.Delete };
  return ApiClient.patch(url, {}, params);
};
